import { createContext, useContext, useState, useCallback } from "react";
import translations from "../i18n/translations";

const LanguageContext = createContext();

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "nl", label: "Nederlands" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Francais" },
  { code: "es", label: "Espanol" },
  { code: "it", label: "Italiano" },
  { code: "pl", label: "Polski" },
  { code: "cs", label: "Cestina" },
  { code: "uk", label: "Українська" },
  { code: "ru", label: "Русский" },
];

const LANG_CODES = LANGUAGES.map((l) => l.code);

export function LanguageProvider({ children, initialLang }) {
  const [language, setLanguage] = useState(
    () => (LANG_CODES.includes(initialLang) ? initialLang : (localStorage.getItem("ll_lang") || "en"))
  );

  // changeLanguage — persist in localStorage AND navigate to same page with new URL prefix.
  // Full page reload keeps SEO clean (server sees the new URL, canonical + hreflang refresh correctly).
  const changeLanguage = useCallback((code) => {
    if (!LANG_CODES.includes(code)) return;
    localStorage.setItem("ll_lang", code);
    if (typeof window !== "undefined") {
      const path = window.location.pathname.replace(new RegExp(`^/${language}(/|$)`), "/");
      const target = `/${code}${path === "/" ? "" : path}${window.location.search}${window.location.hash}`;
      window.location.assign(target);
    } else {
      setLanguage(code);
    }
  }, [language]);

  const t = useCallback(
    (key) => {
      const lang = translations[language] || translations.en;
      return lang[key] || translations.en[key] || key;
    },
    [language]
  );

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
